"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _tableTreeGenerate = _interopRequireDefault(require("./table/tableTreeGenerate"));
var _schemaTreeGenerate = _interopRequireDefault(require("./schemaTreeGenerate"));
var _relation = _interopRequireDefault(require("./relation"));
var _getRequester = _interopRequireDefault(require("./requester/getRequester"));
var _editRequester = _interopRequireDefault(require("./requester/editRequester"));
var _deleteRequester = _interopRequireDefault(require("./requester/deleteRequester"));
var _copyRequester = _interopRequireDefault(require("./requester/copyRequester"));
var _dataStore = _interopRequireDefault(require("./dataStore"));
var _common = require("./utils/common");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /* eslint-disable no-underscore-dangle */
// 缓冲dm操作对象和调用情况，避免console
window.__dm_cache = window.__dm_cache || {};

/**
 * 数据源管理类
*/
var DataManager = /*#__PURE__*/function () {
  /**
   * @param {*} collection 多数据源配置信息
   * @param {*} options 单数据源的初始化信息
   */
  function DataManager(collection, options) {
    (0, _classCallCheck2.default)(this, DataManager);
    this.collection = (0, _lodash.cloneDeep)(collection);
    this.tableInitInfo = options;

    // 配置的表关系集
    this.relation = new _relation.default(this.relationList);
    this.dataStore = new _dataStore.default();
    this.initTime = new Date().getTime();
    this.callInfo = {};
    var dmCache = window.__dm_cache[this.collection.id] || {};
    dmCache[this.initTime] = this;
    window.__dm_cache[this.collection.id] = dmCache;
  }

  /**
   * 存储相关表的扩展配置：删除、赋值等行为
   */
  (0, _createClass2.default)(DataManager, [{
    key: "tableExtendInfoList",
    get: function get() {
      return this.collection.multiConfig.baseConfigList.map(function (item) {
        var data = _objectSpread(_objectSpread({}, item), {}, {
          tableKey: item.collectionId
        });
        delete data.collectionId;
        return data;
      });
    }
    /**
     * 存储相关表的关系配置
     */
  }, {
    key: "relationList",
    get: function get() {
      return this.collection.multiConfig.relationConfigList.map(function (item) {
        var data = _objectSpread(_objectSpread({}, item), {}, {
          mainTable: item.mainId,
          forkTable: item.forkId
        });
        delete data.mainId;
        delete data.forkId;
        return data;
      });
    }
    /**
     * 获取唯一的主表key
     */
  }, {
    key: "mainTableKey",
    get: function get() {
      return this.tableExtendInfoList.find(function (item) {
        return item.isMain;
      }).tableKey;
    }
    /**
     * 获取多个的从表key集合
     */
  }, {
    key: "forkTableKeyList",
    get: function get() {
      return this.tableExtendInfoList.filter(function (item) {
        return !item.isMain;
      }).map(function (item) {
        return item.tableKey;
      });
    }
  }, {
    key: "getTableTree",
    value: function () {
      var _getTableTree = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(tableParams, forkTableKeyList) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _tableTreeGenerate.default)({
                mainTableKey: this.mainTableKey,
                forkTableKeyList: forkTableKeyList || this.forkTableKeyList,
                tableInitInfo: this.tableInitInfo,
                tableParams: tableParams
              }, this.relation, this.tableExtendInfoList, this.dataStore);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableTree(_x, _x2) {
        return _getTableTree.apply(this, arguments);
      }
      return getTableTree;
    }()
  }, {
    key: "getResultStruct",
    value: function getResultStruct(requester) {
      if (requester.errMsg.length > 0) {
        return {
          code: -1,
          message: "\u5171 ".concat(requester.errMsg.length, " \u6B21\u9519\u8BEF\uFF0C\u8BE6\u7EC6\u9519\u8BEF\u4FE1\u606F\uFF1A\n ").concat(requester.errMsg.join('\n')),
          errorData: requester.errMsg
        };
      }
      return {
        code: 0,
        message: 'success'
      };
    }

    /**
     * 转换外部传入的数据
     * @param {*} $dataList
     */
  }, {
    key: "convertData",
    value: function convertData($dataList) {
      var dataList = (0, _lodash.cloneDeep)($dataList);
      if (dataList) {
        if (!Array.isArray(dataList)) {
          dataList = [dataList];
        }
      }
      return dataList;
    }

    // 暴露的调用接口--------------------------------------------------------------------------

    /**
     * 获取主表的单条关联数据
     * @param {*} $options
     */
  }, {
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2($options) {
        var options, uuid, timestamp, result, tableTreeObj, requester, detailResult, _detailResult;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context2.prev = 3;
              if (!(0, _common.noneValue)(options === null || options === void 0 ? void 0 : options.id)) {
                _context2.next = 6;
                break;
              }
              throw Error("get error options is ".concat(JSON.stringify(options)));
            case 6:
              _context2.next = 8;
              return this.getTableTree();
            case 8:
              tableTreeObj = _context2.sent;
              requester = new _getRequester.default(tableTreeObj, uuid);
              _context2.next = 12;
              return requester.getAllDataDetail(options.id);
            case 12:
              detailResult = _context2.sent;
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                _detailResult = (0, _slicedToArray2.default)(detailResult, 1);
                result.data = _detailResult[0];
              }
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              result = {
                code: _context2.t0.code || -1,
                message: _context2.t0.message,
                errorData: _context2.t0
              };
            case 20:
              _context2.prev = 20;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] get error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'get',
                uuid: uuid,
                options: options,
                result: result
              };
              return _context2.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 17, 20, 25]]);
      }));
      function get(_x3) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * 创建主表的单条关联数据
     * @param {*} $options
     */
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3($options) {
        var options, uuid, timestamp, result, data, newList, tableTreeObj, requester, returnData, primaryKey;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context3.prev = 3;
              data = options.data;
              if (data) {
                _context3.next = 7;
                break;
              }
              throw Error("create error options is ".concat(JSON.stringify(options)));
            case 7:
              newList = this.convertData(data);
              _context3.next = 10;
              return this.getTableTree();
            case 10:
              tableTreeObj = _context3.sent;
              requester = new _editRequester.default(tableTreeObj, uuid);
              _context3.next = 14;
              return requester.editAllDataDetail(newList);
            case 14:
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                returnData = tableTreeObj.tableTree.dataList[0] || {};
                primaryKey = tableTreeObj.tableTree.primaryKey;
                result.data = {
                  id: returnData[primaryKey]
                };
              }
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](3);
              result = {
                code: _context3.t0.code || -1,
                message: _context3.t0.message,
                errorData: _context3.t0
              };
            case 21:
              _context3.prev = 21;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] create error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'create',
                uuid: uuid,
                options: options,
                result: result
              };
              if (!(result.code === 0)) {
                _context3.next = 28;
                break;
              }
              _context3.next = 27;
              return this.get({
                id: result.data.id
              });
            case 27:
              return _context3.abrupt("return", _context3.sent);
            case 28:
              return _context3.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 30:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 18, 21, 30]]);
      }));
      function create(_x4) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
    /**
     * update主表的单条关联数据
     * @param {*} $options
     */
  }, {
    key: "update",
    value: function () {
      var _update = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4($options) {
        var options, uuid, timestamp, result, data, oldData, newList, oldList, tableTreeObj, primaryKey, requester, returnData, _primaryKey;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context4.prev = 3;
              data = options.data, oldData = options.oldData;
              if (!(!data || !oldData)) {
                _context4.next = 7;
                break;
              }
              throw Error("update error options is ".concat(JSON.stringify(options)));
            case 7:
              newList = this.convertData(data);
              oldList = this.convertData(oldData);
              _context4.next = 11;
              return this.getTableTree();
            case 11:
              tableTreeObj = _context4.sent;
              // 强校验：update时，不允许主表的数据被删除
              primaryKey = tableTreeObj.tableTree.primaryKey;
              oldList.forEach(function (oldData) {
                if ((0, _common.noneValue)(oldData[primaryKey]) || !newList.find(function (newData) {
                  return newData[primaryKey] === oldData[primaryKey];
                })) {
                  throw Error('update error oldData does not allow delete');
                }
              });
              requester = new _editRequester.default(tableTreeObj, uuid);
              _context4.next = 17;
              return requester.editAllDataDetail(newList, oldList);
            case 17:
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                returnData = tableTreeObj.tableTree.dataList[0] || {};
                _primaryKey = tableTreeObj.tableTree.primaryKey;
                result.data = {
                  id: returnData[_primaryKey]
                };
              }
              _context4.next = 24;
              break;
            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4["catch"](3);
              result = {
                code: _context4.t0.code || -1,
                message: _context4.t0.message,
                errorData: _context4.t0
              };
            case 24:
              _context4.prev = 24;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] update error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'update',
                uuid: uuid,
                options: options,
                result: result
              };
              if (!(result.code === 0)) {
                _context4.next = 31;
                break;
              }
              _context4.next = 30;
              return this.get({
                id: result.data.id
              });
            case 30:
              return _context4.abrupt("return", _context4.sent);
            case 31:
              return _context4.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 33:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 21, 24, 33]]);
      }));
      function update(_x5) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     * delete主表的单条关联数据
     * @param {*} $options
     */
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5($options) {
        var options, uuid, timestamp, result, oldData, oldList, tableTreeObj, requester;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context5.prev = 3;
              oldData = options.oldData;
              if (oldData) {
                _context5.next = 7;
                break;
              }
              throw Error("delete error options is ".concat(JSON.stringify(options)));
            case 7:
              oldList = this.convertData(oldData);
              _context5.next = 10;
              return this.getTableTree();
            case 10:
              tableTreeObj = _context5.sent;
              requester = new _deleteRequester.default(tableTreeObj, uuid);
              _context5.next = 14;
              return requester.deleteAllDataDetail(oldList);
            case 14:
              result = this.getResultStruct(requester);
              _context5.next = 20;
              break;
            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](3);
              result = {
                code: _context5.t0.code || -1,
                message: _context5.t0.message,
                errorData: _context5.t0
              };
            case 20:
              _context5.prev = 20;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] delete error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'delete',
                uuid: uuid,
                options: options,
                result: result
              };
              return _context5.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[3, 17, 20, 25]]);
      }));
      function _delete(_x6) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * copy主表的单条关联数据
     * @param {*} $options
     */
  }, {
    key: "copy",
    value: function () {
      var _copy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6($options) {
        var options, uuid, timestamp, result, oldData, oldList, tableTreeObj, requester, copyResult, _copyResult;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context6.prev = 3;
              oldData = options.oldData;
              if (oldData) {
                _context6.next = 7;
                break;
              }
              throw Error("copy error options is ".concat(JSON.stringify(options)));
            case 7:
              oldList = this.convertData(oldData);
              _context6.next = 10;
              return this.getTableTree();
            case 10:
              tableTreeObj = _context6.sent;
              requester = new _copyRequester.default(tableTreeObj, uuid);
              _context6.next = 14;
              return requester.copyAllDataDetail(oldList);
            case 14:
              copyResult = _context6.sent;
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                _copyResult = (0, _slicedToArray2.default)(copyResult, 1);
                result.data = _copyResult[0];
              }
              _context6.next = 22;
              break;
            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](3);
              result = {
                code: _context6.t0.code || -1,
                message: _context6.t0.message,
                errorData: _context6.t0
              };
            case 22:
              _context6.prev = 22;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] copy error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'copy',
                uuid: uuid,
                options: options,
                result: result
              };
              return _context6.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 27:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 19, 22, 27]]);
      }));
      function copy(_x7) {
        return _copy.apply(this, arguments);
      }
      return copy;
    }()
    /**
     * 获取主表的批量关联数据
     * @param {*} $option
     */
  }, {
    key: "list",
    value: function () {
      var _list = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7($options) {
        var options, uuid, timestamp, result, page, size, include, exclude, filter, sort, tableTreeObj, requester, listResult;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context7.prev = 3;
              page = options.page, size = options.size, include = options.include, exclude = options.exclude, filter = options.filter, sort = options.sort;
              _context7.next = 7;
              return this.getTableTree({
                page: page,
                size: size,
                include: include,
                exclude: exclude,
                filter: filter,
                sort: sort
              });
            case 7:
              tableTreeObj = _context7.sent;
              requester = new _getRequester.default(tableTreeObj, uuid);
              _context7.next = 11;
              return requester.getAllDataList();
            case 11:
              listResult = _context7.sent;
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                result.data = listResult;
              }
              _context7.next = 19;
              break;
            case 16:
              _context7.prev = 16;
              _context7.t0 = _context7["catch"](3);
              result = {
                code: _context7.t0.code || -1,
                message: _context7.t0.message,
                errorData: _context7.t0
              };
            case 19:
              _context7.prev = 19;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] list error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'list',
                uuid: uuid,
                options: options,
                result: result
              };
              return _context7.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 24:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[3, 16, 19, 24]]);
      }));
      function list(_x8) {
        return _list.apply(this, arguments);
      }
      return list;
    }()
    /**
     * 获取主表的批量关联数据
     * @param {*} $options
     */
  }, {
    key: "count",
    value: function () {
      var _count = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8($options) {
        var options, uuid, timestamp, result, filter, tableTreeObj, requester, countResult;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              options = (0, _lodash.cloneDeep)($options);
              uuid = (0, _common.generateUUID)();
              timestamp = new Date().getTime();
              _context8.prev = 3;
              filter = options.filter;
              _context8.next = 7;
              return this.getTableTree({
                filter: filter
              }, []);
            case 7:
              tableTreeObj = _context8.sent;
              requester = new _getRequester.default(tableTreeObj, uuid);
              _context8.next = 11;
              return requester.getAllDataCount();
            case 11:
              countResult = _context8.sent;
              result = this.getResultStruct(requester);
              if (result.code === 0) {
                result.data = countResult;
              }
              _context8.next = 19;
              break;
            case 16:
              _context8.prev = 16;
              _context8.t0 = _context8["catch"](3);
              result = {
                code: _context8.t0.code || -1,
                message: _context8.t0.message,
                errorData: _context8.t0
              };
            case 19:
              _context8.prev = 19;
              if (result.code !== 0) {
                console.error("dm[".concat(uuid, "] count error"), options, result);
              }
              this.callInfo[timestamp] = {
                type: 'count',
                uuid: uuid,
                options: options,
                result: result
              };
              return _context8.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 24:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[3, 16, 19, 24]]);
      }));
      function count(_x9) {
        return _count.apply(this, arguments);
      }
      return count;
    }()
    /**
     * 获取聚合的dataSchema
     */
  }, {
    key: "getEntitySchema",
    value: function () {
      var _getEntitySchema = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var timestamp, tableTreeObj, result, _timestamp;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              timestamp = new Date().getTime();
              _context9.prev = 1;
              _context9.next = 4;
              return this.getTableTree();
            case 4:
              tableTreeObj = _context9.sent;
              result = (0, _lodash.cloneDeep)((0, _schemaTreeGenerate.default)(tableTreeObj.tableTree));
              this.callInfo[timestamp] = {
                type: 'getEntitySchema',
                result: result
              };
              return _context9.abrupt("return", (0, _lodash.cloneDeep)(result));
            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](1);
              console.error('dm getEntitySchema error', _context9.t0);
              _timestamp = new Date().getTime();
              this.callInfo[_timestamp] = {
                type: 'getEntitySchema',
                result: _context9.t0.message || '未知错误'
              };
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 10]]);
      }));
      function getEntitySchema() {
        return _getEntitySchema.apply(this, arguments);
      }
      return getEntitySchema;
    }()
  }]);
  return DataManager;
}();
var _default = DataManager;
exports.default = _default;